import room from "../assets/room.jpg";
import man from "../assets/man.png";
import ArrowLeft from "../assets/Vector3.png";
import ArrowRight from "../assets/Vector1.png";
import Arrow from "../assets/Vector 4.png";
import Header from "../Sharedcomponents/Header/Header";

export const Background = () => {
  return (
    <div>
      <Header />
      <div
        className="relative w-full bg-center bg-cover bg-no-repeat"
        style={{ backgroundImage: `url(${room})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-80 z-0"></div>

        <div className="absolute z-0 h-full w-full flex justify-start opacity-60 overflow-hidden">
          <img
            src={ArrowLeft}
            alt="Arrow"
            className="w-[250px] sm:w-[400px] md:w-[600px] lg:w-[728px]"
          />
        </div>
        <div className="absolute z-0 h-full flex justify-start left-4 sm:left-8 md:left-16 overflow-hidden">
          <img
            src={ArrowLeft}
            alt="Arrow"
            className="w-[250px] sm:w-[400px] md:w-[600px] lg:w-[728px]"
          />
        </div>
        <div className="absolute z-0 h-full flex justify-end right-4 sm:right-10 md:right-[90px] opacity-60 overflow-hidden">
          <img
            src={ArrowRight}
            alt="Arrow"
            className="w-[250px] sm:w-[400px] md:w-[600px] lg:w-[728px]"
          />
        </div>
        <div className="absolute z-0 h-full flex justify-end right-2 sm:right-6 md:right-[30px] overflow-hidden">
          <img
            src={Arrow}
            alt="Arrow"
            className="w-[250px] sm:w-[400px] md:w-[600px] lg:w-[728px]"
          />
        </div>

        <div className="absolute z-50 text-[#FFFFFF] flex flex-col justify-center items-center h-screen w-full text-center px-4 mt-10">
          <div>
            <p className="font-league flex items-start text-xs sm:text-sm md:text-base 2xl:text-4xl">
              Kosmos Badminton Academy (KBA).
            </p>
            <p className="font-langit text-3xl sm:text-5xl md:text-3xl lg:text-4xl xl:text-[30px] 2xl:text-[103px] lg:leading-[40px] 2xl:leading-[100px]">
              REGISTRATION
            </p>
          </div>
          <div>
            <p className="font-langit text-3xl sm:text-5xl md:text-3xl lg:text-4xl xl:text-[30px] 2xl:text-[103px] lg:leading-[40px] 2xl:leading-[100px]">
              FORM
            </p>
          </div>
        </div>

        <div
          style={{
            position: "absolute",
            top: "50%",
            left: 0,
            width: "100%",
            height: "50%",
            background: "linear-gradient(to bottom, transparent, black)",
            opacity: 0.9,
            pointerEvents: "none",
            zIndex: 40,
          }}
        />

        <div className="relative z-10 h-screen flex justify-center overflow-hidden pl-14 pt-24 lg:pl-24">
          <img
            src={man}
            alt="man"
            className="h-[155%] md:h-[150%] opacity-80"
          />
        </div>

        <div className="absolute right-0 top-1/3 -translate-y-1/2 z-50 flex flex-col items-center space-y-4 pr-2">
          <div
            className="text-white font-extralight text-[10px] md:text-[16px] tracking-widest font-league rotate-180"
            style={{ writingMode: "vertical-rl" }}
          >
            SCROLL DOWN
          </div>
          <div className="w-[1px] h-10 md:h-24 bg-gray-400" />
        </div>
      </div>
    </div>
  );
};
